import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { guestRouters } from './guestRoutes';
import { privateRouters } from './privateRoutes';
import { publicRouters } from './publicRoutes';
import { LanguageProvider } from '@/features/LanguageContext';
import { GlobalLayout } from '@/layouts';
import { kioskRoutes } from './kioskRoutes';

const ErrorBoundary = lazy(() => import('../pages/ErrorBoundary'));

export const router = createBrowserRouter([
  {
    element: <LanguageProvider />,
    children: [
      {
        element: <GlobalLayout />,
        errorElement: <ErrorBoundary />,
        children: [
          ...kioskRoutes,
          ...guestRouters,
          ...privateRouters,
          ...publicRouters,
        ],
      },
    ],
  },
]);
